import { JustifiedView } from '@commoncore/utils/JustifiedViewUtil';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { LocalStorageSvc } from '../services/localStorage.service';
export class IndexDBImplementation {

    public router: any;
    public http: any;
    public route: any;
    public universalService: any;
    public globalService: any;
    public allFilesnextLink = "";
    public allFilespreviousLink = "";
    public sortOrder: any;
    public flag: boolean = false;
    public rootFolderCheck: boolean = false;
    public docheignt: number = 0;
    public toppos: number = 0;
    public customMetadata: any;
    public JsView: JustifiedView;
    public customSort: any;
    // public sortByDateArray:any = [];
    // public sortByNameArray:any = [];
    public multiSelect: any;
    public listService: any;
    public contextMenuService: any;
    listImpl: any;
    allfileslistsize = 0;
    foldersController: any;
    foldersViewImpl: any;
    localStorageSvc: LocalStorageSvc;
    loggerService: any;
    refetchData: boolean = false;
    db: IndexedDBModule;
    indexDBData: any = ""
    public static singleInstance: any;
    

    constructor(globalService) {
        this.globalService = globalService;
        this.localStorageSvc = globalService.getLocalStorageSvcRef();
        this.setHandler(globalService)
    }

    public setHandler(globalService) {
        this.universalService = globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.route = globalService.getActivatedRoute();
        this.db = IndexedDBModule.getInstance(globalService);
        this.localStorageSvc = globalService.getLocalStorageSvcRef();


    }

    public static getInstance(globalService): IndexDBImplementation {
        if (this.singleInstance == null) {
          this.singleInstance = new IndexDBImplementation(globalService);
          return this.singleInstance;
        } else {
          return this.singleInstance;
        }
      }

    getIndexDBStoresTobeUpdate(object,isParentKeyRoot) {
        var objectType = object.objectType;
        var displayName = (object.objectType == "FE" && object.displayName)?object.displayName.toLowerCase():"";
        var storesName = []
        if(isParentKeyRoot){
            /*storesName.push('AllFilesMetadata_List_Name_Desc');
            storesName.push('AllFilesMetadata_List_Date_Asc');
            storesName.push('AllFilesMetadata_List_Date_Desc');
            storesName.push('AllFilesMetadata_List_Size_Asc');
            storesName.push('AllFilesMetadata_List_Size_Desc');
            storesName.push('AllFilesMetadata_List_Type_Asc');
            storesName.push('AllFilesMetadata_List_Type_Desc');*/
            
    
            if (objectType == 'FR') {
                storesName.push('AllFiles_FolderMetadata_Name_Asc');
                storesName.push('AllFiles_FolderMetadata_Date_Desc');

                storesName.push('AllFiles_FolderMetadata_Name_Desc');
                storesName.push('AllFiles_FolderMetadata_Date_Asc');
                storesName.push('AllFiles_FolderMetadata_CreatedDate_Asc');
                storesName.push('AllFiles_FolderMetadata_CreatedDate_Desc');
            } else {
                storesName.push('AllFilesMetadata_Grid_Name_Asc');
                storesName.push('AllFilesMetadata_Grid_Date_Desc');
                storesName.push('AllFilesMetadata_Grid_Name_Desc');
                storesName.push('AllFilesMetadata_Grid_Date_Asc');
                storesName.push('AllFilesMetadata_Grid_CreatedDate_Asc');
                storesName.push('AllFilesMetadata_Grid_CreatedDate_Desc');
                if (displayName == 'video') {
                    storesName.push('VideosMetadata_ObjectName');
                    storesName.push('VideosMetadata_FileCreatedDate');
                    storesName.push('VideosMetadata_CreatedDate');
                    storesName.push('VideosMetadata_ObjectName_Desc');
                    storesName.push('VideosMetadata_FileCreatedDate_Asc');
                    storesName.push('VideosMetadata_CreatedDate_Asc');
                } else if (displayName == 'image') {
                    storesName.push('PhotosMetadata_ObjectName');
                    storesName.push('PhotosMetadata_FileCreatedDate');
                    storesName.push('PhotosMetadata_CreatedDate');
                    storesName.push('PhotosMetadata_ObjectName_Desc');
                    storesName.push('PhotosMetadata_FileCreatedDate_Asc');
                    storesName.push('PhotosMetadata_CreatedDate_Asc');
                } else if (displayName == 'audio') {
                    storesName.push('AudiosMetadata_Name_Asc');
                    storesName.push('AudiosMetadata_Name_Desc');
                    storesName.push('AudiosMetadata_FileCreatedDate_Asc');
                    storesName.push('AudiosMetadata_FileCreatedDate_Desc');
                    storesName.push('AudiosMetadata_CreatedDate_Asc');
                    storesName.push('AudiosMetadata_CreatedDate_Desc');
                } else {
                    storesName.push('DocumentMetadata_Name_Asc');
                    storesName.push('DocumentMetadata_Name_Desc');
                    storesName.push('DocumentMetadata_Size_Asc');
                    storesName.push('DocumentMetadata_Size_Desc');
                    storesName.push('DocumentMetadata_Type_Asc');
                    storesName.push('DocumentMetadata_Type_Desc');
                    storesName.push('DocumentMetadata_Type_Asc');
                    storesName.push('DocumentMetadata_Type_Desc');
                    storesName.push('DocumentMetadata_FileCreatedDate_Asc');
                    storesName.push('DocumentMetadata_FileCreatedDate_Desc');
                    storesName.push('DocumentMetadata_CreatedDate_Asc');
                    storesName.push('DocumentMetadata_CreatedDate_Desc');
                }
            }

        }else{
        
                if (displayName == 'video') {
                    storesName.push('VideosMetadata_ObjectName');
                    storesName.push('VideosMetadata_FileCreatedDate');
                    storesName.push('VideosMetadata_CreatedDate');
                    storesName.push('VideosMetadata_ObjectName_Desc');
                    storesName.push('VideosMetadata_FileCreatedDate_Asc');
                    storesName.push('VideosMetadata_CreatedDate_Asc');
                } else if (displayName == 'image') {
                    storesName.push('PhotosMetadata_ObjectName');
                    storesName.push('PhotosMetadata_FileCreatedDate');
                    storesName.push('PhotosMetadata_CreatedDate');
                    storesName.push('PhotosMetadata_ObjectName_Desc');
                    storesName.push('PhotosMetadata_FileCreatedDate_Asc');
                    storesName.push('PhotosMetadata_CreatedDate_Asc');
                } else if (displayName == 'audio') {
                    storesName.push('AudiosMetadata_Name_Asc');
                    storesName.push('AudiosMetadata_Name_Desc');
                    storesName.push('AudiosMetadata_FileCreatedDate_Asc');
                    storesName.push('AudiosMetadata_FileCreatedDate_Desc');
                    storesName.push('AudiosMetadata_CreatedDate_Asc');
                    storesName.push('AudiosMetadata_CreatedDate_Desc');
                } else if (objectType != 'FR') {
                    storesName.push('DocumentMetadata_Name_Asc');
                    storesName.push('DocumentMetadata_Name_Desc');
                    storesName.push('DocumentMetadata_Size_Asc');
                    storesName.push('DocumentMetadata_Size_Desc');
                    storesName.push('DocumentMetadata_Type_Asc');
                    storesName.push('DocumentMetadata_Type_Desc');
                    storesName.push('DocumentMetadata_Type_Asc');
                    storesName.push('DocumentMetadata_Type_Desc');
                    storesName.push('DocumentMetadata_FileCreatedDate_Asc');
                    storesName.push('DocumentMetadata_FileCreatedDate_Desc');
                    storesName.push('DocumentMetadata_CreatedDate_Asc');
                    storesName.push('DocumentMetadata_CreatedDate_Desc');
                }
            
            
        }
     

        return storesName;
    }

    getStoresByType(type) {
        var storesName = [];
        switch(type){
            case "ALL_FILES":
                /*storesName.push('AllFilesMetadata_List_Name_Asc');
                storesName.push('AllFilesMetadata_List_Name_Desc');
                storesName.push('AllFilesMetadata_List_Date_Asc');
                storesName.push('AllFilesMetadata_List_Date_Desc');
                storesName.push('AllFilesMetadata_List_Size_Asc');
                storesName.push('AllFilesMetadata_List_Size_Desc');
                storesName.push('AllFilesMetadata_List_Type_Asc');
                storesName.push('AllFilesMetadata_List_Type_Desc');*/
                storesName.push('AllFilesMetadata_Grid_Name_Asc');
                storesName.push('AllFilesMetadata_Grid_Date_Desc');

                storesName.push('AllFilesMetadata_Grid_Name_Desc');
                storesName.push('AllFilesMetadata_Grid_Date_Asc');
                storesName.push('AllFilesMetadata_Grid_CreatedDate_Asc');
                storesName.push('AllFilesMetadata_Grid_CreatedDate_Desc');
                break;
            case "FILTERS":
                storesName.push('VideosMetadata_ObjectName');
                storesName.push('VideosMetadata_FileCreatedDate');
                storesName.push('VideosMetadata_CreatedDate');
                storesName.push('PhotosMetadata_ObjectName');
                storesName.push('PhotosMetadata_FileCreatedDate');
                storesName.push('PhotosMetadata_CreatedDate');
                storesName.push('AudiosMetadata_Name_Asc');
                storesName.push('AudiosMetadata_Name_Desc');
                storesName.push('AudiosMetadata_FileCreatedDate_Asc');
                storesName.push('AudiosMetadata_FileCreatedDate_Desc');
                storesName.push('AudiosMetadata_CreatedDate_Asc');
                storesName.push('AudiosMetadata_CreatedDate_Desc');
                storesName.push('DocumentMetadata_Name_Asc');
                storesName.push('DocumentMetadata_Name_Desc');
                storesName.push('DocumentMetadata_Size_Asc');
                storesName.push('DocumentMetadata_Size_Desc');
                storesName.push('DocumentMetadata_Type_Asc');
                storesName.push('DocumentMetadata_Type_Desc');
                storesName.push('DocumentMetadata_Type_Asc');
                storesName.push('DocumentMetadata_Type_Desc');
                storesName.push('DocumentMetadata_FileCreatedDate_Asc');
                storesName.push('DocumentMetadata_FileCreatedDate_Desc');
                storesName.push('DocumentMetadata_CreatedDate_Asc');
                storesName.push('DocumentMetadata_CreatedDate_Desc');


                storesName.push('VideosMetadata_ObjectName_Desc');
                storesName.push('VideosMetadata_FileCreatedDate_Asc');
                storesName.push('VideosMetadata_CreatedDate_Asc');

                storesName.push('PhotosMetadata_ObjectName_Desc');
                storesName.push('PhotosMetadata_FileCreatedDate_Asc');
                storesName.push('PhotosMetadata_CreatedDate_Asc');
                break;
            case "FOLDERS":
                storesName.push('AllFiles_FolderMetadata_Name_Asc');
                storesName.push('AllFiles_FolderMetadata_Date_Desc');
                /*storesName.push('AllFilesMetadata_List_Name_Desc');
                storesName.push('AllFilesMetadata_List_Date_Asc');
                storesName.push('AllFilesMetadata_List_Date_Desc');
                storesName.push('AllFilesMetadata_List_Size_Asc');
                storesName.push('AllFilesMetadata_List_Size_Desc');
                storesName.push('AllFilesMetadata_List_Type_Asc');
                storesName.push('AllFilesMetadata_List_Type_Desc');*/

                storesName.push('AllFiles_FolderMetadata_Name_Desc');
                storesName.push('AllFiles_FolderMetadata_Date_Asc');
                storesName.push('AllFiles_FolderMetadata_CreatedDate_Asc');
                storesName.push('AllFiles_FolderMetadata_CreatedDate_Desc');
                break;
            case "VIDEOS":
                storesName.push('VideosMetadata_ObjectName');
                storesName.push('VideosMetadata_FileCreatedDate');
                storesName.push('VideosMetadata_CreatedDate');


                storesName.push('VideosMetadata_ObjectName_Desc');
                storesName.push('VideosMetadata_FileCreatedDate_Asc');
                storesName.push('VideosMetadata_CreatedDate_Asc');
                break;
            case "PHOTOS":
                storesName.push('PhotosMetadata_ObjectName');
                storesName.push('PhotosMetadata_FileCreatedDate');
                storesName.push('PhotosMetadata_CreatedDate');


                storesName.push('PhotosMetadata_ObjectName_Desc');
                storesName.push('PhotosMetadata_FileCreatedDate_Asc');
                storesName.push('PhotosMetadata_CreatedDate_Asc');
                break;
            case "AUDIOS":
                storesName.push('AudiosMetadata_Name_Asc');
                storesName.push('AudiosMetadata_Name_Desc');
                storesName.push('AudiosMetadata_FileCreatedDate_Asc');
                storesName.push('AudiosMetadata_FileCreatedDate_Desc');
                storesName.push('AudiosMetadata_CreatedDate_Asc');
                storesName.push('AudiosMetadata_CreatedDate_Desc');
                break;
            case "DOCUMENTS":
                storesName.push('DocumentMetadata_Name_Asc');
                storesName.push('DocumentMetadata_Name_Desc');
                storesName.push('DocumentMetadata_Size_Asc');
                storesName.push('DocumentMetadata_Size_Desc');
                storesName.push('DocumentMetadata_Type_Asc');
                storesName.push('DocumentMetadata_Type_Desc');
                storesName.push('DocumentMetadata_Type_Asc');
                storesName.push('DocumentMetadata_Type_Desc');
                storesName.push('DocumentMetadata_FileCreatedDate_Asc');
                storesName.push('DocumentMetadata_FileCreatedDate_Desc');
                storesName.push('DocumentMetadata_CreatedDate_Asc');
                storesName.push('DocumentMetadata_CreatedDate_Desc');
                break;
            case "ALBUMS":
                storesName.push('MyAlbumsList');
                break
    
        }
        return storesName;
    }

    addFolderIndexDB(response) {
        // this.saveToIndexDB(respone.objects[0].operation, this.getIndexDBStoresTobeUpdate(respone.objects[0].object), respone.objects[0].object);
        let storeArray = this.getIndexDBStoresTobeUpdate(response[0],true)
        //saveToIndexDB (operationName, storeArray, data) {
        var self = this;
        let folderAddedonExistingStore=false
        storeArray.forEach((storeName) => {
            // if(this.universalService.currentOpenIndexDBStoreforFolder!="" &&  this.universalService.currentOpenIndexDBStoreforFolder == storeName){
            //     self.db.add(this.universalService.currentOpenIndexDBStoreforFolder, response);
            // }
            
            self.db.getAllData(storeName,"").then(async function (result: any) {
                if (result && result.length > 0) {
                    if(self.universalService.currentOpenIndexDBStoreforFolder!="" &&  self.universalService.currentOpenIndexDBStoreforFolder == storeName){
                        folderAddedonExistingStore = true
                    }
                    if (storeName.includes("FolderMetadata")) {
                        result.map(function (object) {
                            delete object.id;
                        })
                        await self.db.clearStore(storeName)
                        let newData = response.concat(result)
                        self.db.bulkAdd(storeName, newData);

                    } else {
                        await self.db.add(storeName, response[0]);
                    }



                }
            }, function (error) {
                console.log("error in folderAdd is not present",error);
            });
        });
        // on empty indexdb table data is adding
        /*if(self.universalService.currentOpenIndexDBStoreforFolder!="" && !folderAddedonExistingStore ){
            self.db.add(self.universalService.currentOpenIndexDBStoreforFolder, response[0]);
        }*/

    }

    addFileIndexDB(response) {
        var userData = this.localStorageSvc.getUserData(true);        
        if(response.parentObjectKey == userData["rootFolderKey"]){
             // this.saveToIndexDB(respone.objects[0].operation, this.getIndexDBStoresTobeUpdate(respone.objects[0].object), respone.objects[0].object);
            let storeArray = this.getIndexDBStoresTobeUpdate(response,true)
            //saveToIndexDB (operationName, storeArray, data) {
            var self = this;
            
            storeArray.forEach((storeName) => {
                if(self.universalService.currentOpenIndexDBStoreforFile!="" && self.universalService.currentOpenIndexDBStoreforFile == storeName ){
                     self.db.add(self.universalService.currentOpenIndexDBStoreforFile, response);
                }else{
                    self.db.getAllData(storeName,"").then(async function (result: any) {
                        if (result && result.length > 0) {
                                var res = self.db.add(storeName, response);
                        }
                    }, function (error) {
                        console.log("error in folderAdd is not present",error);
                    });
                }
                
            });
        }else {
            // this.saveToIndexDB(respone.objects[0].operation, this.getIndexDBStoresTobeUpdate(respone.objects[0].object), respone.objects[0].object);
           let storeArray = this.getIndexDBStoresTobeUpdate(response,false)
           //saveToIndexDB (operationName, storeArray, data) {
           var self = this;

           storeArray.forEach((storeName) => {
                // if(this.universalService.currentOpenIndexDBStoreforFile == storeName ){
                //     self.db.add(this.universalService.currentOpenIndexDBStoreforFile, response);
                // }else{
                    self.db.getAllData(storeName,"").then(async function (result: any) {
                        if (result && result.length > 0) {
                                self.db.add(storeName, response);
                        }
                    }, function (error) {
                        console.log("error in folderAdd is not present",error);
                    });
                //}
           });
       }
       

    }


    //Add bulk records
    /*addBulkFileIndexDB(response) {
        let storeArray = this.getIndexDBStoresTobeUpdate(response)
        var self = this;

        storeArray.forEach((storeName) => {
            self.db.getAllData(storeName).then(async function (result: any) {
                if (result && result.length > 0) {
                        self.db.bulkAdd(storeName, response);
                }
            }, function (error) {
                console.log("error in bulkAdd..  is not present",error);
            });
        });
    }*/

    addBulkFileIndexDB(response, storeData) {
        //let storeArray = this.getIndexDBStoresTobeUpdate(response)
        var self = this;

        storeData.forEach((storeName) => {
            self.db.getAllData(storeName,"").then(async function (result: any) {
                if (result && result.length > 0) {
                        self.db.bulkAdd(storeName, response);
                }
            }, function (error) {
                console.log("error in bulkAdd..  is not present",error);
            });
        });
    }

    updateOnMove(dataArray, storeData) {
        //let storeArray = this.getIndexDBStoresTobeUpdate(response)
        var self = this;
        dataArray.forEach((data) => {
            storeData.forEach((storeName) => {
              self.db.getByIndex(storeName, 'objectKey', data.objectKey).then(function(object: any) {
                object.parentObjectKey = data.parentObjectKey;
                self.db.update(storeName, object);
              }, function(error) {
                console.log("objectKey is not present",error);
              });
            });
          });
    }
    
    clearMyFilesStores() {
        var folderStores = this.getStoresByType('FOLDERS');
        var allFilesStores = this.getStoresByType('ALL_FILES');
        var filterStores = this.getStoresByType('FILTERS');

        var storeArray = [...folderStores, ...allFilesStores, ...filterStores];
        storeArray.forEach((storeName) => {
            this.db.clearStore(storeName);
            this.db.deleteByKey("NextLink",storeName);
        });
    }

    clearStores(storesType) {
        var stores = this.getStoresByType(storesType);
      //  var allFilesStores = this.getStoresByType('ALL_FILES');
        //var filterStores = this.getStoresByType('FILTERS');

        var storeArray = [...stores];
        storeArray.forEach((storeName) => {
            this.db.clearStore(storeName);
            this.db.deleteByKey("NextLink",storeName);

        });
    }

/*
    updateOnPreviewGetLink(apiResponse) {
        var allFilesStores = this.getStoresByType('ALL_FILES');
        let FILTERS=''
        let filterStores = []
        if(this.universalService.currentTab == "allfiles"){
            
        }else if(this.universalService.currentTab == "photos"){
            filterStores = this.getStoresByType('PHOTOS'); 
        }else if(this.universalService.currentTab == "videos"){
            filterStores= this.getStoresByType('VIDEOS'); 
        }else if(this.universalService.currentTab == "audio"){
            filterStores= this.getStoresByType('AUDIOS'); 
        }else if(this.universalService.currentTab == "docs"){
            filterStores= this.getStoresByType('DOCUMENTS');  
        }

        var storeArray = [...allFilesStores, ...filterStores];

        var self = this;
        let data = this.universalService.selectedFile 
       // dataArray.forEach((data) => {
            storeArray.forEach((storeName) => {
              self.db.getByIndex(storeName, 'objectKey', data.objectKey).then(function(object: any) {
                object.isShared = true;
                object.shareKey = apiResponse.shareKey;
                object.shareLink = apiResponse.shareLink;
                object.shareType = apiResponse.shareType;
                
                self.db.update(storeName, object);
              }, function(error) {
                console.log("objectKey is not present",error);
              });
            });
         // });
    }*/
}